import React from 'react';
import Button from '../../../components/ui/Button';

const BulkActions = ({ selectedCount, onDownload, onDelete, onClear }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[110] animate-slide-in-bottom">
      <div className="bg-card border border-border rounded-lg shadow-lg elevation-3 flex items-center gap-3 px-4 py-3">
        <span className="text-sm font-medium text-foreground">
          {selectedCount} {selectedCount === 1 ? 'file' : 'files'} selected
        </span>
        <div className="h-6 w-px bg-border" />
        <Button
          variant="outline"
          size="sm"
          iconName="Download"
          iconPosition="left"
          onClick={onDownload}
        >
          Download
        </Button>
        <Button
          variant="destructive"
          size="sm"
          iconName="Trash2"
          iconPosition="left"
          onClick={onDelete}
        >
          Delete
        </Button>
        <button
          onClick={onClear}
          className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default BulkActions;